import { z } from "zod";

/**
 * Password requirements for the application.
 * Used for both frontend validation and display purposes.
 */
export const passwordRequirements = {
  minLength: 8,
  patterns: {
    uppercase: /[A-Z]/,
    lowercase: /[a-z]/,
    number: /[0-9]/,
    special: /[^A-Za-z0-9]/,
  },
};

/**
 * Zod schema for validating passwords with complexity requirements.
 * Enforces:
 * - Minimum 8 characters
 * - At least one uppercase letter
 * - At least one lowercase letter
 * - At least one number
 * - At least one special character
 */
export const passwordSchema = z
  .string()
  .min(passwordRequirements.minLength, "Password must be at least 8 characters")
  .refine((val) => passwordRequirements.patterns.uppercase.test(val), {
    message: "Password must contain at least one uppercase letter",
  })
  .refine((val) => passwordRequirements.patterns.lowercase.test(val), {
    message: "Password must contain at least one lowercase letter",
  })
  .refine((val) => passwordRequirements.patterns.number.test(val), {
    message: "Password must contain at least one number",
  })
  .refine((val) => passwordRequirements.patterns.special.test(val), {
    message: "Password must contain at least one special character",
  });
